module.exports = __webpack_public_path__ + "img/19.e91a709b.jpg";